import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SortingPage from './pages/SortingPage';
import SearchingPage from './pages/SearchingPage';
import ArrayOperationsPage from './pages/ArrayOperationsPage';
import LinkedListPage from './pages/LinkedListPage';
import GraphPage from './pages/GraphPage';
import StackQueuePage from './pages/StackQueuePage';
import TreePage from './pages/TreePage';
import TriePage from './pages/TriePage';
import RecursionBacktrackingPage from './pages/RecursionBacktrackingPage';
import DynamicProgrammingPage from './pages/DynamicProgrammingPage';
import HashMapPage from './pages/HashMapPage';
import BitManipulationPage from './pages/BitManipulationPage';
import HeapPage from './pages/HeapPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sorting" element={<SortingPage />} />
        <Route path="/searching" element={<SearchingPage />} />
        <Route path="/array-operations" element={<ArrayOperationsPage />} />
        <Route path="/linked-list" element={<LinkedListPage />} />
        <Route path="/graph" element={<GraphPage />} />
        <Route path="/stack-queue" element={<StackQueuePage />} />
        <Route path="/tree" element={<TreePage />} />
        <Route path="/trie" element={<TriePage />} />
        <Route path="/recursion-backtracking" element={<RecursionBacktrackingPage />} />
        <Route path="/dynamic-programming" element={<DynamicProgrammingPage />} />
        <Route path="/hashmap" element={<HashMapPage />} />
        <Route path="/bit-manipulation" element={<BitManipulationPage />} />
        <Route path="/heap" element={<HeapPage />} />
      </Routes>
    </Router>
  );
}

export default App;
